export var PainLocationType;
(function (PainLocationType) {
    PainLocationType["PAIN"] = "PAIN";
    PainLocationType["FRACTURE"] = "FRACTURE";
    PainLocationType["IMPLANT"] = "IMPLANT";
    PainLocationType["MOVEMENT"] = "MOVEMENT";
    PainLocationType["CUSTOM"] = "CUSTOM";
})(PainLocationType || (PainLocationType = {}));
//# sourceMappingURL=pain-location-type.enum.js.map